import { Grid, Typography } from "@mui/material";
import React, { useEffect } from "react";
import { Alert, Form } from "../../../layout";
import { Button, Input } from "../../../controls";
import { Model, UseForm } from "../../../hooks";
import { useState } from "react";
import { useTranslation } from "react-i18next";

const VerifyFrgtCode = (props) => {
  const { setActiveStep, forgotVal, setForgotVal } = props;
  const { ForgotMdl } = Model();
  const { t } = useTranslation(["common", "validation"]);
  const [alert, setAlert] = useState({
    isOpen: false,
    type: "",
    title: "",
    subTitle: "",
  });
  const [loading, setLoading] = useState(false);
  const { values, setValues, errors, setErrors, handleInpChg } =
    UseForm(ForgotMdl);

  const validateForm = () => {
    let temp = {};
    temp.verCode =
      values.verCode !== "" ? "" : t("validation:verCodeRequired");
    setErrors({ ...temp });
    return Object.values(temp).every((x) => x === "");
  };

  const submitForm = (e) => {
    e.preventDefault();
    if (validateForm()) {
      setActiveStep(2);
      setLoading(false);
      values.forgotStep = 2;
    }
  };

  useEffect(() => {
    setValues(forgotVal);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  useEffect(() => {
    setForgotVal({ ...values });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [values]);

  return (
    <>
      <Form noValidate onSubmit={submitForm}>
        <Grid container className="p-[10px] pt-0" spacing={3}>
          <Grid item xs={12} className="text-center !mt-[30px] pb-[30px]">
            <h2 className="text-[22px] font-medium uppercase text-gray-500">
              {t("verificationCode")}
            </h2>
            <div className="relative flex justify-center mt-[5px]">
              <div className="border-bottom w-[60px]" />
            </div>
          </Grid>
          <Grid item xs={12} className="mb-[20px]">
            <Typography variant="p" className="text-gray-500">
              {t("verCodeSentTo")}{" "}
              <strong>{values.email}</strong>
            </Typography>
          </Grid>
          <Grid item xs={12} className="text-right">
            <Input
              type="number"
              label={t("enterVerificationCode")}
              name="verCode"
              size="medium"
              value={values.verCode}
              onChange={handleInpChg}
              error={errors.verCode}
              className="input-primary w-full !mb-[10px]"
            />
            <span className="text-gray-500 cursor-pointer hover:text-primary hover:underline mr-[5px]">
              {t("resendCode")}
            </span>
          </Grid>
          <Grid item xs={12} className="text-center grid gap-2">
            <Button
              loading={loading}
              type="submit"
              size="large"
              className="w-full"
            >
              {t("verify")}
            </Button>
            <Button
              onClick={() => setActiveStep(0)}
              size="large"
              variant="text"
              className="w-full"
            >
              {t("back")}
            </Button>
          </Grid>
        </Grid>
      </Form>
      {/* Alert  */}
      <Alert alert={alert} setAlert={setAlert} />
    </>
  );
};

export default VerifyFrgtCode;
